export default __webpack_public_path__ + "static/media/visitorsSquare.2371230c.svg";